import { reactive } from 'vue';
import { appConfig } from '@/config';
export const desktopInstall = reactive({ available: false, installed: false, busy: false });
let installEvent = null;
let initialized = false;
export function initializeDesktopInstall() {
  if (initialized || appConfig.capacitorApp) return;
  initialized = true;
  const standalone = window.matchMedia('(display-mode: standalone)');
  const update = () => { desktopInstall.installed = standalone.matches || navigator.standalone === true; };
  update();
  standalone.addEventListener?.('change', update);
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    installEvent = event;
    desktopInstall.available = true;
  });
  window.addEventListener('appinstalled', () => {
    installEvent = null;
    desktopInstall.available = false;
    desktopInstall.installed = true;
  });
}
export async function requestDesktopInstall() {
  if (desktopInstall.busy) return '';
  if (desktopInstall.installed) return 'installed';
  if (!installEvent) return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ? 'ios' : 'manual';
  const event = installEvent;
  installEvent = null;
  desktopInstall.available = false;
  desktopInstall.busy = true;
  try {
    await event.prompt();
    const choice = await event.userChoice;
    return choice.outcome === 'accepted' ? 'accepted' : 'cancelled';
  } catch { return 'manual'; }
  finally { desktopInstall.busy = false; }
}
